/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useRef } from "react";
import PlainInputCharacter from "../../../../atoms/PlainInputCharacter";
import cs from "classnames";
import classes from "./Location.module.scss";
import { CHARACTER_SUBMISSION_KEY } from "../../WritingCompetitionForm";
import { StoreContext } from "../../../../../contexts";
import { observer } from "mobx-react-lite";

const Location = observer(({ characterFormLocation, authorization }) => {
  const { common } = useContext(StoreContext);
  const lastPrefilledChildIdRef = useRef(null);
  const previousValueRef = useRef(null);
  const wasManuallyClearedRef = useRef(false);

  const submissionData = common.get(CHARACTER_SUBMISSION_KEY);
  const location = submissionData.location ?? null;
  const personsData = authorization?.persons || [];

  // Prefill location from first selected writer
  useEffect(() => {
    const selectedChilds = submissionData?.selected_childs || [];
    const currentValue = characterFormLocation.value || "";
    const previousValue = previousValueRef.current;
    
    // Check if field already has a value from saved data - if so, don't overwrite it
    const hasExistingValue = currentValue && currentValue.trim() !== "";
    
    // Track if user manually cleared the field (value went from non-empty to empty)
    if (previousValue && previousValue.trim() !== "" && !hasExistingValue) {
      wasManuallyClearedRef.current = true;
    }
    
    // Update previous value ref
    previousValueRef.current = currentValue;
    
    if (selectedChilds.length === 0) {
      // Reset the prefilled child ref when no children are selected
      lastPrefilledChildIdRef.current = null;
      wasManuallyClearedRef.current = false;
      return;
    }

    // If field already has a value, don't overwrite it
    if (hasExistingValue) {
      // Reset manual clear flag if field has value again
      wasManuallyClearedRef.current = false;
      return;
    }

    // If user manually cleared the field, don't prefill again
    if (wasManuallyClearedRef.current) {
      return;
    }

    if (selectedChilds.length > 0 && personsData.length > 0) {
      // Get only the FIRST selected child
      const firstChildId = selectedChilds[0];
      
      // Only prefill if we haven't prefilled for this child yet
      if (lastPrefilledChildIdRef.current === firstChildId) {
        return;
      }
      
      const firstChild = personsData.find(
        (person) => person.id.toString() === firstChildId.toString()
      );

      if (firstChild && firstChild.city) {
        // Format location as "City, State, Country" for first child only
        const locationParts = [
          firstChild.city,
          firstChild.state,
          firstChild.country,
        ].filter(Boolean); // Remove empty values

        const firstChildLocation = locationParts.join(", ");

        // Only update if the value is different to prevent infinite loops
        if (firstChildLocation && currentValue !== firstChildLocation) {
          characterFormLocation.onChange({
            target: { value: firstChildLocation },
            touched: false,
          });
          // Track that we've prefilled for this child
          lastPrefilledChildIdRef.current = firstChildId;
          wasManuallyClearedRef.current = false;
        }
      }
    }
  }, [submissionData?.selected_childs, personsData, characterFormLocation.value]);

  return (
    <div className={cs(classes.locationContainer)}>
      <div className={cs(classes.characterFieldContainer, characterFormLocation.error && classes.errorbg)}>
        <label htmlFor="place-name-input">
          Where do you live? <span className={cs(classes.red)}> * </span>
        </label>
        <PlainInputCharacter
          error={characterFormLocation.error}
          id="place-name-input"
          label={characterFormLocation.label}
          value={characterFormLocation.value}
          onChange={characterFormLocation.onChange}
          placeHolder="Short Answer text"
        />
      </div>
    </div>
  );
});

export default Location;
